// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PropertySingleLine {
  display: flex;
  flex-direction: column;
  font-size: 1.0em;
  font-family: sans-serif;
  /*width: auto;*/
  text-align: left;
}
.PropertySingleLine:nth-child(even) {
  background-color: #ddd;
}
.PropertySingleLine:nth-child(odd) {
  background-color: #fff;
}
.psl-override-header-color {
  background-color: #ddd !important;
}
.psl-selected {
  background-color: #d6e3ff;
}

.PropertySingleLine .psl-table-wrapper {
}

.PropertySingleLine .psl-cell {
  display: flex;
  flex-direction: row;
}

.PropertySingleLine .psl-column {
  font-size: 0.7em;
}
.psl-cell {
}

.psl-column {
  text-align: center;
  border: 1px solid white;
  overflow-wrap: break-word;
  word-wrap: break-word;
  white-space: normal;
  padding-top: 0.4em;
}

.psl-select {
  min-width: 2em;
  max-width: 2em;
}
.psl-map {
}
.psl-gallery {
}
.psl-mls {
  min-width: 6em;
  max-width: 6em;
}
.psl-mls a:hover, a:visited, a:active {
  color: blue;
}
.psl-status {
  min-width: 3em;
  max-width: 3em;
}
.psl-expired {
  color: red;
}
.psl-withdrawn {
  color: black;
}
.psl-sold {
  color: blue;
}
.psl-active {
  color: green;
}
.psl-inc {
  min-width: 2em;
  max-width: 2em;
}
.psl-price {
  min-width: 8em;
  max-width: 8em;
}
.psl-type {
  min-width: 8em;
  max-width: 8em;
}
.psl-subtype {
  min-width: 8em;
  max-width: 8em;

}
.psl-addr {
  min-width: 18em;
  max-width: 18em;
}
.psl-town {
  min-width: 14em;
  max-width: 14em;
}
.psl-sqft {
  min-width: 4em;
  max-width: 4em;
}
.psl-lotsz {
  min-width: 5em;
  max-width: 5em;
}

.psl-br {
  min-width: 2.4em;
  max-width: 2.4em;
}
.psl-fb {
  min-width: 2em;
  max-width: 2em;
}
.psl-hb {
  min-width: 2em;
  max-width: 2em;
}
.psl-year {
  min-width: 4em;
  max-width: 4em;
}
.psl-dom {
  min-width: 4em;
  max-width: 4em;
}

.psl-invis-img {
  opacity: 0;
}
input.psl-select {
  margin-top: 0.4em;
  margin-bottom: 0.4em;
}
.fancy-image-gallery-wrapper {
  position: absolute;
  top: 0px;
  left: 0px;
  margin-top: 2em;
  text-align: center;
  z-index: 101;
}
.psl-backdrop {
  position: absolute !important;
  top: 0px;
  left: -4000em;
  background-color: black;
  opacity: 0.8;
  width: 90000em;
  height: 90000em;
  z-index: 100;
}

.error {
  color: red;
  padding: 0.2em;
}
.psl-button-no-border {
  border: none;
}
`, "",{"version":3,"sources":["webpack://./src/PropertySingleLine.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,iCAAiC;AACnC;AACA;EACE,yBAAyB;AAC3B;;AAEA;AACA;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;AACA;AACA;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;AACA;AACA;AACA;AACA;AACA;EACE,cAAc;EACd,cAAc;AAChB;AACA;EACE,WAAW;AACb;AACA;EACE,cAAc;EACd,cAAc;AAChB;AACA;EACE,UAAU;AACZ;AACA;EACE,YAAY;AACd;AACA;EACE,WAAW;AACb;AACA;EACE,YAAY;AACd;AACA;EACE,cAAc;EACd,cAAc;AAChB;AACA;EACE,cAAc;EACd,cAAc;AAChB;AACA;EACE,cAAc;EACd,cAAc;AAChB;AACA;EACE,cAAc;EACd,cAAc;;AAEhB;AACA;EACE,eAAe;EACf,eAAe;AACjB;AACA;EACE,eAAe;EACf,eAAe;AACjB;AACA;EACE,cAAc;EACd,cAAc;AAChB;AACA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,cAAc;AAChB;AACA;EACE,cAAc;EACd,cAAc;AAChB;AACA;EACE,cAAc;EACd,cAAc;AAChB;AACA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;AACA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,6BAA6B;EAC7B,QAAQ;EACR,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,YAAY;AACd;;AAEA;EACE,UAAU;EACV,cAAc;AAChB;AACA;EACE,YAAY;AACd","sourcesContent":[".PropertySingleLine {\n  display: flex;\n  flex-direction: column;\n  font-size: 1.0em;\n  font-family: sans-serif;\n  /*width: auto;*/\n  text-align: left;\n}\n.PropertySingleLine:nth-child(even) {\n  background-color: #ddd;\n}\n.PropertySingleLine:nth-child(odd) {\n  background-color: #fff;\n}\n.psl-override-header-color {\n  background-color: #ddd !important;\n}\n.psl-selected {\n  background-color: #d6e3ff;\n}\n\n.PropertySingleLine .psl-table-wrapper {\n}\n\n.PropertySingleLine .psl-cell {\n  display: flex;\n  flex-direction: row;\n}\n\n.PropertySingleLine .psl-column {\n  font-size: 0.7em;\n}\n.psl-cell {\n}\n\n.psl-column {\n  text-align: center;\n  border: 1px solid white;\n  overflow-wrap: break-word;\n  word-wrap: break-word;\n  white-space: normal;\n  padding-top: 0.4em;\n}\n\n.psl-select {\n  min-width: 2em;\n  max-width: 2em;\n}\n.psl-map {\n}\n.psl-gallery {\n}\n.psl-mls {\n  min-width: 6em;\n  max-width: 6em;\n}\n.psl-mls a:hover, a:visited, a:active {\n  color: blue;\n}\n.psl-status {\n  min-width: 3em;\n  max-width: 3em;\n}\n.psl-expired {\n  color: red;\n}\n.psl-withdrawn {\n  color: black;\n}\n.psl-sold {\n  color: blue;\n}\n.psl-active {\n  color: green;\n}\n.psl-inc {\n  min-width: 2em;\n  max-width: 2em;\n}\n.psl-price {\n  min-width: 8em;\n  max-width: 8em;\n}\n.psl-type {\n  min-width: 8em;\n  max-width: 8em;\n}\n.psl-subtype {\n  min-width: 8em;\n  max-width: 8em;\n\n}\n.psl-addr {\n  min-width: 18em;\n  max-width: 18em;\n}\n.psl-town {\n  min-width: 14em;\n  max-width: 14em;\n}\n.psl-sqft {\n  min-width: 4em;\n  max-width: 4em;\n}\n.psl-lotsz {\n  min-width: 5em;\n  max-width: 5em;\n}\n\n.psl-br {\n  min-width: 2.4em;\n  max-width: 2.4em;\n}\n.psl-fb {\n  min-width: 2em;\n  max-width: 2em;\n}\n.psl-hb {\n  min-width: 2em;\n  max-width: 2em;\n}\n.psl-year {\n  min-width: 4em;\n  max-width: 4em;\n}\n.psl-dom {\n  min-width: 4em;\n  max-width: 4em;\n}\n\n.psl-invis-img {\n  opacity: 0;\n}\ninput.psl-select {\n  margin-top: 0.4em;\n  margin-bottom: 0.4em;\n}\n.fancy-image-gallery-wrapper {\n  position: absolute;\n  top: 0px;\n  left: 0px;\n  margin-top: 2em;\n  text-align: center;\n  z-index: 101;\n}\n.psl-backdrop {\n  position: absolute !important;\n  top: 0px;\n  left: -4000em;\n  background-color: black;\n  opacity: 0.8;\n  width: 90000em;\n  height: 90000em;\n  z-index: 100;\n}\n\n.error {\n  color: red;\n  padding: 0.2em;\n}\n.psl-button-no-border {\n  border: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
